export function localDateKey(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function formatFrenchDate(date) {
  return date.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
}

export function nextLocalMidnight(now = new Date()) {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
}

const MONTHS = {
  janvier: 0, février: 1, fevrier: 1, mars: 2, avril: 3, mai: 4, juin: 5,
  juillet: 6, août: 7, aout: 7, septembre: 8, octobre: 9, novembre: 10, décembre: 11, decembre: 11,
};

export function parseFrenchDate(value) {
  const text = String(value || "").trim().toLowerCase();
  const french = text.match(/^(\d{1,2})\s+([a-zéû]+)\.?\s+(\d{4})$/);
  const numeric = text.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  let day, month, year;
  if (french) [day, month, year] = [Number(french[1]), MONTHS[french[2]], Number(french[3])];
  else if (numeric) [day, month, year] = [Number(numeric[1]), Number(numeric[2]) - 1, Number(numeric[3])];
  else if (iso) [day, month, year] = [Number(iso[3]), Number(iso[2]) - 1, Number(iso[1])];
  else {
    // Model deadlines may include surrounding text, such as "avant le 10 octobre 2026".
    const embedded = text.match(/\b(?:\d{1,2}\s+[a-zéû]+\.?\s+\d{4}|\d{1,2}[/-]\d{1,2}[/-]\d{4}|\d{4}-\d{2}-\d{2})\b/);
    return embedded ? parseFrenchDate(embedded[0]) : null;
  }
  const date = new Date(year, month, day);
  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day ? date : null;
}

export function isOverdue(deadline) {
  const date = parseFrenchDate(deadline);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return !!date && date < today;
}

const escapeIcs = (text) => String(text).replace(/\\/g, "\\\\").replace(/\r?\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");

// RFC 5545: fold at 75 UTF-8 octets without splitting an accented character.
function foldIcsLine(line) {
  let result = "", bytes = 0;
  for (const char of line) {
    const size = new TextEncoder().encode(char).length;
    if (bytes + size > 75) { result += "\r\n "; bytes = 1; }
    result += char;
    bytes += size;
  }
  return result;
}

export function buildCalendarEvent(analysis, now = new Date()) {
  const date = parseFrenchDate(analysis.deadline);
  if (!date) return null;
  const end = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
  const alarm = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, 9);
  const utcStamp = (value) => value.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
  return [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Marianne//Echeances//FR", "CALSCALE:GREGORIAN", "BEGIN:VEVENT",
    `UID:${escapeIcs(analysis.id || analysis.example_id || "document")}-${localDateKey(date)}@marianne`,
    `DTSTAMP:${utcStamp(now)}`,
    `DTSTART;VALUE=DATE:${localDateKey(date).replace(/-/g, "")}`,
    `DTEND;VALUE=DATE:${localDateKey(end).replace(/-/g, "")}`,
    `SUMMARY:${escapeIcs(`${analysis.type_courrier} : ${analysis.expediteur}`)}`,
    `DESCRIPTION:${escapeIcs(`Échéance : ${analysis.deadline}\n${(analysis.actions || []).join("\n")}`)}`,
    "BEGIN:VALARM", `TRIGGER;VALUE=DATE-TIME:${utcStamp(alarm)}`, "ACTION:DISPLAY",
    `DESCRIPTION:${escapeIcs(`Échéance : ${analysis.deadline}`)}`, "END:VALARM",
    "END:VEVENT", "END:VCALENDAR", "",
  ].map(foldIcsLine).join("\r\n");
}
